import React, { useState } from "react";
import { submitGrievance } from "../services/api";
import "./GrievanceForm.css";

function GrievanceForm() {
  const [submitting, setSubmitting] = useState(false);
  const [fileInputKey, setFileInputKey] = useState(0);
  const [formData, setFormData] = useState({
    name: "",
    category: "",
    admissionNo: "",
    email: "",
    mobile: "",
    grievanceType: "",
    description: "",
    file: null,
  });

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "file") {
      setFormData({ ...formData, file: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      !formData.name ||
      !formData.category ||
      !formData.email ||
      !formData.mobile ||
      !formData.grievanceType ||
      !formData.description?.trim()
    ) {
      alert(
        "Please fill all mandatory fields, including the grievance description."
      );
      return;
    }

    const fd = new FormData();
    fd.append("name", formData.name);
    fd.append("category", formData.category);
    fd.append("admissionNo", formData.admissionNo || "");
    fd.append("email", formData.email.trim());
    fd.append("mobile", formData.mobile);
    fd.append("grievanceType", formData.grievanceType);
    fd.append("description", formData.description.trim());
    if (formData.file) {
      fd.append("file", formData.file);
    }

    setSubmitting(true);
    try {
      const { data } = await submitGrievance(fd);

      const emailLine = data.emailSent
        ? `A confirmation email has been sent to ${formData.email.trim()}.`
        : `Grievance saved, but email was NOT sent. ${
            data.emailError ? `Error: ${data.emailError}` : ""
          }`;

      alert(
        `Grievance submitted successfully.\nYour grievance number: ${data.grievanceNo}\n${emailLine}`
      );
      setFormData({
        name: "",
        category: "",
        admissionNo: "",
        email: "",
        mobile: "",
        grievanceType: "",
        description: "",
        file: null,
      });
      setFileInputKey((k) => k + 1);
    } catch (err) {
      console.error("Submit grievance failed:", err);
      let msg =
        err.response?.data?.message ||
        err.message ||
        "Could not submit grievance. Please try again.";

      // Axios shows "Network Error" for CORS/connection failures where no HTTP response is received.
      if (msg === "Network Error") {
        msg =
          "Network error while submitting. Make sure the backend is running at https://grs.jeccac.in and is reachable from the browser.";
      }

      alert(msg);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="form-card">
      <h2>Online Grievance Form</h2>

      <form onSubmit={handleSubmit}>
        <div className="form-row">
          <input
            type="text"
            name="name"
            placeholder="Name *"
            value={formData.name}
            onChange={handleChange}
            required
          />

          <select
            name="category"
            value={formData.category}
            onChange={handleChange}
            required
          >
            <option value="">Select Category *</option>
            <option>Student</option>
            <option>Staff</option>
            <option>Parent</option>
          </select>
        </div>

        <div className="form-row">
          <input
            type="text"
            name="admissionNo"
            placeholder="Admission No / Employee ID"
            value={formData.admissionNo}
            onChange={handleChange}
          />

          <input
            type="email"
            name="email"
            placeholder="Email ID *"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-row">
          <input
            type="tel"
            name="mobile"
            placeholder="Mobile Number *"
            value={formData.mobile}
            onChange={handleChange}
            pattern="[0-9]{10}"
            required
          />

          <select
            name="grievanceType"
            value={formData.grievanceType}
            onChange={handleChange}
            required
          >
            <option value="">Select Grievance Type *</option>
            <option>Mark Issue</option>
            <option>Fee Issue</option>
            <option>Harassment</option>
            <option>Other</option>
          </select>
        </div>

        <textarea
          name="description"
          placeholder="Detail your grievance (max 4000 characters) *"
          value={formData.description}
          onChange={handleChange}
          maxLength="4000"
          required
        />

        {/* FILE UPLOAD */}
        <div className="file-upload">
          <label>Upload Supporting Document (optional)</label>
          <input
            key={fileInputKey}
            type="file"
            name="file"
            accept=".pdf,.jpg,.jpeg,.png"
            onChange={handleChange}
          />
        </div>

        <button type="submit" className="submit-btn" disabled={submitting}>
          {submitting ? "Submitting…" : "Submit Grievance"}
        </button>
      </form>
    </div>
  );
}

export default GrievanceForm;
